import { render } from "./widgetHeaderCompact.vue?vue&type=template&id=61a9e1ec&scoped=true"
import script from "./widgetHeaderCompact.vue?vue&type=script&lang=js"
export * from "./widgetHeaderCompact.vue?vue&type=script&lang=js"

import "./widgetHeaderCompact.vue?vue&type=style&index=0&id=61a9e1ec&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a9e1ec"]])

export default __exports__